import { render, staticRenderFns } from "./BoxOverview.vue?vue&type=template&id=51c350a3&"
import script from "./BoxOverview.vue?vue&type=script&lang=ts&"
export * from "./BoxOverview.vue?vue&type=script&lang=ts&"
import style0 from "./BoxOverview.vue?vue&type=style&index=0&id=51c350a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BoxOverview.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxOverview.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QSkeleton,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QSkeleton,QInnerLoading,QSpinnerTail})
